import Tab from '../components/tab'

export default {
  Tab
}



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/resources/components.js